import React, { useEffect, useState } from "react";
import ReportLayout from "../components/ReportLayout";
import { DateField } from "../components/DateField";
import { SelectField } from "../components/SelectField";
import API_BASE_URL from "../utilities/ApiConfig";
import axios from "axios";

export default function ParganaWiseReport() {
  const [form, setForm] = useState({
    fromDate: "",
    toDate: "",
    report: "",
    district: "",
    sro: "",
    pargana: "",
  });

  const [districts, setDistricts] = useState([]);
  const [sros, setSros] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/Master/get_District_Mas`)
      .then((res) => setDistricts(res.data.data));
  }, []);

  useEffect(() => {
    if (form.district) {
      fetchSros(form.district);
    } else {
      setSros([]);
    }
  }, [form.district]);

  const fetchSros = async (dcode) => {
    const res = await axios.get(
      `${API_BASE_URL}/Master/get_sro_master_data?dcode=${dcode}`
    );
    setSros(res.data.data);
  };

  const handleChange = (field) => (e) =>
    setForm((f) => ({ ...f, [field]: e.target.value }));
  const handleDownload = () => console.log(form);

  return (
    <ReportLayout title="Pargana Wise Report" onDownload={handleDownload}>
      <SelectField
        id="report"
        label="Report Type"
        value={form.report}
        onChange={handleChange("report")}
        options={[
          { value: "revenue", label: "Revenue Comparison" },
          { value: "documents", label: "Document Count" },
          { value: "top-deeds", label: "Top Deeds" },
        ]}
      />
      <DateField
        id="fromDate"
        label="From Date"
        value={form.fromDate}
        onChange={handleChange("fromDate")}
      />
      <DateField
        id="toDate"
        label="To Date"
        value={form.toDate}
        onChange={handleChange("toDate")}
      />
      <SelectField
        id="district"
        label="Select District"
        value={form.district}
        onChange={handleChange("district")}
        options={districts.map((d) => ({
          value: d.dcode,
          label: d.districtName,
        }))}
      />
      <SelectField
        id="sro"
        label="Select SRO"
        value={form.sro}
        onChange={handleChange("sro")}
        options={sros.map((s) => ({ value: s.srocode, label: s.sroname }))}
      />
      <SelectField
        id="pargana"
        label="Select Pargana"
        value={form.pargana}
        onChange={handleChange("pargana")}
        // options={districts.map((d) => ({
        //   value: d.dcode,
        //   label: d.districtName,
        // }))}
        options={[
          { value: "a", label: "pargana 1" },
          { value: "b", label: "pargana 2" },
        ]}
      />
    </ReportLayout>
  );
}
